export type auth0B2BUserType = {
  "https://sisitrip.com": {
    mark: {
      is_b2c: boolean;
      company_type: string;
      company_id: number;
      complete_user_profile: boolean;
      complete_company_profile: boolean;
    };
  };
  nickname: string;
  name: string;
  picture: string;
  updated_at: string;
  email: string;
  email_verified: boolean;
  sub: string;
};

export function userIsB2B(user: auth0B2BUserType | any): boolean {
  if (!user) return false;

  return Object.keys(user as object).includes("https://sisitrip.com");
}
